import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import SectionUs3 from "./page_us/Solution-US-3/SectionUs3.js";
import { useEffect } from "react";



const PlafondsMursTendus = () =>{
    
useEffect(() => {
  const previousTitle = document.title;

  // ========= HELPERS =========
  const manageTag = (name, value, isProperty = false) => {
    const attribute = isProperty ? "property" : "name";
    let tag = document.querySelector(`meta[${attribute}='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute(attribute, name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", value);
    return tag;
  };

  // ========= TITLE =========
  document.title =
    "Store Maroc | Intérieur & Extérieur Anti-Chaleur – UNIK SYSTEM";

  // ========= BASIC SEO =========
  manageTag(
    "description",
    "Stores au Maroc avec UNIK SYSTEM : stores intérieurs et extérieurs sur mesure, protection solaire, réduction de chaleur et confort thermique pour maisons et bureaux."
  );

  manageTag(
    "keywords",
    "store maroc, store casablanca, store interieur maroc, store exterieur maroc, store anti chaleur maroc, store automatique maroc, protection solaire maroc, UNIK SYSTEM store"
  );

  manageTag("robots", "index, follow");
  manageTag("author", "UNIK SYSTEM");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", "https://unik-system.com/store-interieur-maroc");

  // ========= IMAGE =========
  const imageUrl =
    "https://unik-system.com/static/media/22Salle%20de%20conf%C3%A9rence%20%C3%A9quip%C3%A9e%20de%20stores%20int%C3%A9rieurs%20occultants%20pour%20protection%20solaire%20et%20confort%20visuel_imgupscaler.ai_B.01000a6aacdecbb0825a.webp";

  // ========= OPEN GRAPH =========
  manageTag(
    "og:title",
    "Store Maroc – Protection Solaire & Design | UNIK SYSTEM",
    true
  );
  manageTag(
    "og:description",
    "Stores sur mesure pour réduire la chaleur et améliorer le confort thermique.",
    true
  );
  manageTag("og:image", imageUrl, true);
  manageTag("og:url", "https://unik-system.com/store-interieur-maroc", true);
  manageTag("og:type", "website", true);
  manageTag("og:locale", "fr_FR", true);

  // ========= TWITTER =========
  manageTag("twitter:card", "summary_large_image");
  manageTag(
    "twitter:title",
    "Store Maroc – UNIK SYSTEM"
  );
  manageTag(
    "twitter:description",
    "Stores design et protection solaire pour maisons et bureaux."
  );
  manageTag("twitter:image", imageUrl);

  // ========= SCHEMA (LOCAL BUSINESS + SERVICE) =========
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "UNIK SYSTEM",
    url: "https://unik-system.com",
    description:
      "Spécialiste en stores intérieurs et extérieurs et protection solaire au Maroc.",
    address: {
      "@type": "PostalAddress",
      addressCountry: "MA",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Stores & Protection Solaire",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Store Intérieur Design"
          }
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Store Extérieur Anti-Chaleur"
          }
        }
      ]
    }
  };

  let script = document.querySelector("#schema-us-solar-store");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-us-solar-store";
    document.head.appendChild(script);
  }
  script.innerHTML = JSON.stringify(schema);

  // ========= FAQ SCHEMA =========
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Quels types de stores proposez-vous ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Stores intérieurs, extérieurs, automatiques et solutions sur mesure."
        }
      },
      {
        "@type": "Question",
        name: "Les stores réduisent-ils la chaleur ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Oui, ils permettent de réduire significativement la chaleur et améliorer le confort thermique."
        }
      },
      {
        "@type": "Question",
        name: "Pour quels espaces ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Maisons, bureaux, commerces et espaces professionnels."
        }
      }
    ]
  };

  let faqScript = document.querySelector("#faq-schema-us-solar-store");
  if (!faqScript) {
    faqScript = document.createElement("script");
    faqScript.type = "application/ld+json";
    faqScript.id = "faq-schema-us-solar-store";
    document.head.appendChild(faqScript);
  }
  faqScript.innerHTML = JSON.stringify(faqSchema);

  // ========= CLEANUP =========
  return () => {
    document.title = previousTitle;
    if (script) script.remove();
    if (faqScript) faqScript.remove();
  };
}, []);




  




  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs3/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;